exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3mgcKGibzxgIC1jCksSkQI{padding:20px}._3mgcKGibzxgIC1jCksSkQI a{font-weight:500;font-size:13px;margin-right:30px}\n", ""]);

// Exports
exports.locals = {
	"links": "_3mgcKGibzxgIC1jCksSkQI"
};